import { Injectable, inject } from '@angular/core';
import { OvertimeDataSourceService } from '@wilson/shift-timeline/assignments-gantt-chart';
import { Observable } from 'rxjs';
import { FindStaffDataService } from './find-staff-data.service';

@Injectable()
export class FindStaffOvertimeDataSourceServiceService extends OvertimeDataSourceService {
  private findStaffDataService = inject(FindStaffDataService);

  override isLoadingUsersOvertimesStream(): Observable<boolean> {
    return this.findStaffDataService.isLoadingUsersOvertimes$;
  }

  override userOvertimeMinutesStream(
    userId: string,
  ): Observable<number | undefined> {
    return this.findStaffDataService.userOvertimeMinutesStream(userId);
  }
}
